const serverUri = "https://backend.modinet.io";

export default serverUri;



// WEBPACK FOOTER //
// ./src/config.js